<template>
    <div class="hotel-terms">
        <Translation
            class="hotel-terms-description"
            :translate="{ key: 'cancellation.cancellation_policy_terms' }" />
        <Divider color="lightGrey" thickness="1" topMargin="xxl" bottomMargin="xl" />
        <div class="hotel-terms-cart-cancellation">
            <CartCancellation :product="product" />
        </div>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { HotelProduct } from '@/api/Cart/cart.interfaces';
    import CartCancellation from '@/components/shared/Cancellation/CartCancellation/CartCancellation.vue';
    import Divider from '@ui/components/Divider/Divider.vue';
    import Translation from '@ui/components/Translation/Translation.vue';

    export default defineComponent({
        name: 'Terms',
        components: {
            Translation,
            Divider,
            CartCancellation,
        },
        props: {
            product: {
                type: Object as PropType<HotelProduct>,
                required: true,
            },
        },
    });
</script>

<style scoped lang="scss">
    @forward 'Terms';
</style>
